<template>
  <div class="favorite">
      <div class="favorite__title">
        <h1>Избранные товары</h1>
      </div>
      <div class="favorite__list__block">
        <div class="favorite__clear" v-if="FAVORITE.length == 0">
            <p>
                Нет избранных товаров <router-link to="/" tag="a">перейдите к покупкам чтобы добавить в избранные</router-link>
            </p>
        </div>
        <FavoriteItem  
            v-for="(item, index) in FAVORITE"
            :key="item.id"
            :cart_data_item="item" 
            @deleteFromFavorite="deleteFromFavorite(index)"
            @addToCart="addToCart"
        />
      </div>
  </div>
</template>

<script>
import FavoriteItem from '@/components/FavoriteItem'
import {mapGetters} from 'vuex'
import {mapActions} from 'vuex'

export default {
  name: 'favorite',
  components: {
      FavoriteItem
  },
  methods: {
    ...mapActions([
        'DELETE_FROM_FAVORITE',
        'ADD_TO_CART'
    ]),
     deleteFromFavorite(index) {
        this.DELETE_FROM_FAVORITE(index)
     },
     addToCart(index) {
        this.ADD_TO_CART(index)
        this.$toasted.show('Добавлен в корзину').goAway(1500)
     } 
  },
  computed: {
      ...mapGetters(['FAVORITE']),
  }
}
</script>
<style scoped lang="less">
@baseMedia: 900px;

.favorite {
    width: 1200px;
    margin: 0 auto;
    background: white;
    overflow: hidden;
    @media (max-width: @baseMedia) {
        width: 95%;
    }
    .favorite__title {
        width: 100%;
        padding-top: 20px;
        padding-bottom: 20px;
        text-align: center;
        @media (max-width: @baseMedia) {
            padding-top: 10px;
            padding-bottom: 10px;
        }
        h1 {
            color: #4a4a4a;
            font-size: 30px;
            @media (max-width: @baseMedia) {
                font-size: 20px;
            }
        }
    }
    .favorite__clear {
        width: 100%;
        height: 350px;
        display: flex;
        justify-content: center;
        align-items: center;
        @media (max-width: @baseMedia) {
            text-align: center;
        }
        p {
            color: #4a4a4a;
            font-size: 30px;
            @media (max-width: @baseMedia) {
                font-size: 19px;
            }
            a {
                color: #000;
            }
        }
    }
    .favorite__list__block {
        width: 100%;
        height: 80vh;
        overflow-y: scroll;
    }
    .favorite__list__block::-webkit-scrollbar-track
    {
        background-color: transparent;
    }

    .favorite__list__block::-webkit-scrollbar
    {
        width: 10px;
    }

    .favorite__list__block::-webkit-scrollbar-thumb
    {
        border-radius: 2px;
        background-color: #680;
    }
    .all__price {
        width: 100%;
        padding-top: 20px;
        padding-bottom: 20px;
        text-align: center;
        background: #f5f5f5;
        p {
            font-size: 20px;
        }
    }
}
</style>